import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Popover } from '@barges/react';
import { analyticsService } from '@common/analytics';
import classes from '../classes.module.scss';
import {
  getTopImage, getTopSection, getBottomSection, rednerCloseIcon, renderGeneralMessage
} from './processing_status_utils';

const trackPageVisitHandler = (okMessage, isAffiliatePromoPopup, errorType) => {
  if (okMessage && !isAffiliatePromoPopup) analyticsService.trackPageVisit('payment received popup');
  if (errorType === 'spending_limits') analyticsService.trackPageVisit('increase spending limit popup');
};

function ProcessingStatus({
  purchaseResponce: {
    okMessage, cashbackAmount, errorMessage, recoverable, retriable,
    errorType, errorTitle
  } = {},
  t, onFocusProcessingWindow, userLoading = false, onRetry, onConfirm, purchaseURL, isCreditCard = false, onClose,
  buttonTitle, chatType, isSideMenu, isAffiliatePromoPopup, purchaseAmount, bonus, error, visible, notShowPurchaseSuccessPoppup = false
}) {
  useEffect(() => {
    trackPageVisitHandler(okMessage, isAffiliatePromoPopup, errorType);
  }, [errorType, okMessage]);

  const renderTopImg = () => {
    if (isAffiliatePromoPopup || errorMessage) {
      return getTopImage({ isAffiliatePromoPopup, errorMessage });
    }
    return null;
  };

  useEffect(() => {
    if (okMessage && notShowPurchaseSuccessPoppup) {
      onConfirm();
    }
  }, [okMessage]);

  const renderProcessingStatus = () => (
    <Popover
      isOpen={ visible }
      renderTopOverlay={ renderTopImg }
      centered
      renderCloseButton={ () => rednerCloseIcon({
        okMessage, errorType, isAffiliatePromoPopup, onClose
      }) }
      className="processing-status-popover"
      contentClassName="popoverContentRadius24"
      overlayClassName={ classes.popoverOverlayContainer }
    >
      <div className={ classes.dialogContainer }>
        <div>
          { getTopSection({
            errorMessage, t, okMessage,  isAffiliatePromoPopup, purchaseAmount, bonus, errorTitle
          }) }
        </div>
        <br className={ classes.dialogContainerBr } />
        <div style={ { display: 'flex' } }>
          { renderGeneralMessage({
            isAffiliatePromoPopup, okMessage, bonus, errorMessage, error, isCreditCard,
            onFocusProcessingWindow, t
          }) }
        </div>
        <br className={ classes.dialogContainerBr } />
        <div className={ classes.bottomRow }>
          { getBottomSection({
            okMessage, errorMessage, error, userLoading, errorType, purchaseURL, onRetry,
            recoverable, retriable, t, isAffiliatePromoPopup, onConfirm, buttonTitle,
            cashbackAmount, isSideMenu, chatType, isCreditCard
          }) }

        </div>
      </div>
    </Popover>
  );

  return renderProcessingStatus();
}

ProcessingStatus.propTypes = {
  purchaseResponce: PropTypes.shape({
    errorMessage: PropTypes.string,
    okMessage: PropTypes.string,
    cashbackAmount: PropTypes.string,
    recoverable: PropTypes.bool,
    retriable: PropTypes.bool,
    errorType: PropTypes.string
  }),
  t: PropTypes.func.isRequired,
  onFocusProcessingWindow: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  onRetry: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  userLoading: PropTypes.bool,
  isCreditCard: PropTypes.bool,
  purchaseURL: PropTypes.string.isRequired,
  buttonTitle: PropTypes.string.isRequired,
  chatType: PropTypes.string.isRequired,
  isSideMenu: PropTypes.bool.isRequired,
  isAffiliatePromoPopup: PropTypes.bool.isRequired,
  purchaseAmount: PropTypes.number.isRequired,
  bonus: PropTypes.number.isRequired,
  error: PropTypes.object,
  visible: PropTypes.bool.isRequired,
  notShowPurchaseSuccessPoppup: PropTypes.bool
};

export default ProcessingStatus;
